const mapping: Record<string, string> = {
  id: 'c=>c.Id',
  key: 'c=>c.Key',
  value: 'c=>c.Value',
  type: 'c=>c.Type',
}

export const mapSortDynamicCounterParameterParams = (key: string) =>
  mapping[key]
